import {
    type UpdateOldPresidentResponseType,
    type UpdateOldPresidentRequestType
} from "./type";
import {
    request
} from "../request";

const updateOldPresident = async (params: UpdateOldPresidentRequestType): Promise<UpdateOldPresidentResponseType> => {
    return await request<UpdateOldPresidentResponseType>("/content/updateOldPresident", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default updateOldPresident;
